import { helpers, maxLength, required, url } from '@vuelidate/validators'
import type { TInstance } from '../validators.types'

export function useWebsite(
  field: string,
  t: TInstance,
) {
  return ({
    [`${field}`]: {
      required: helpers.withMessage(
        () => t('formValidatorMessages.website.required'),
        required,
      ),
      maxLength: helpers.withMessage(
        () => t('formValidatorMessages.website.maxLength'),
        maxLength(255),
      ),
      url: helpers.withMessage(
        () => t('formValidatorMessages.website.invalid'),
        url,
      ),
    },
  })
}
